<button type="button" class="btn-close" (click)="onClose()"></button>
<container-element [ngSwitch]="currentLegacyVideoPageType">
  <app-fileswhofor
    *ngSwitchCase="sharedFilesType.WhoFor"
    (goToReciepent)="goToReciepent($event)"
  >
  </app-fileswhofor>
  <app-selectreciepents
    *ngSwitchCase="sharedFilesType.SelectReciepent"
    (Share)="sharelink($event)"
    [shareType]="shareType"
    [form]="form"
    (shareToOther)="shareToOther()"
    (Back)="goBack()"
    [professionalInfo]="creatorId"
    (shareToTpa)="shareLinkTPA($event)"
  >
  </app-selectreciepents>
</container-element>
